module.exports = "<ng-scrollbar>\n<p *ngFor=\"let text of texts\" [innerHtml]=\"text\" class=\"mat-small\"></p>\n</ng-scrollbar>"